module.exports = __webpack_public_path__ + "static/media/progman_13.8da7a4dc.ico";